import React from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { ConsoleRouteMap } from "./routes";
import lazyLoad from "shared/utils/lazyLoad";
import AppWrapper from "./appWrapper";
import { useAuthority } from "context/authority";
import ConsentBannerContainer from "../../../shared/consentManagement";
import { ConsentProvider } from "../../../context/consent";
const Platform = lazyLoad(() => import("../modules/platform"));
const Client = lazyLoad(() => import("../modules/client"));
const EventSeries = lazyLoad(() => import("../modules/eventSeries"));
const Registration = lazyLoad(() => import("../modules/registration"));
const Program = lazyLoad(() => import("../modules/program"));
const Login = lazyLoad(() => import("../modules/login"));
const ResetPassword = lazyLoad(() => import("../modules/resetPassword"));
const ForgotPassword = lazyLoad(() => import("../modules/forgotPassword"));
const AcceptUserRole = lazyLoad(() => import("../modules/acceptUserRole"));
const EventAgendaInIFrame = lazyLoad(() => import("../modules/iframe/eventAgenda"));
const SponsorOrganizationInIFrame = lazyLoad(() => import("../modules/iframe/sponsorOrganization"));

function NavigateToUserHomePage() {
  const authorities = useAuthority();
  const navigate = useNavigate();
  const userType = authorities.config.userType;

  React.useEffect(() => {
    if (userType) {
      navigate(authorities.config.homePage);
    }
  }, [userType, authorities.config, navigate]);

  return null;
}

/**
 * Console Router
 */
export default function ConsoleRouter() {
  return (
    <Router>
      <Routes>
        <Route path={ConsoleRouteMap.HOME.path} element={<AppWrapper />}>
          <Route index element={<NavigateToUserHomePage />} />
          <Route path={`${ConsoleRouteMap.HOME.path}/*`} element={<Platform />} />
          <Route path={`${ConsoleRouteMap.CLIENT.path}/*`} element={<Client />} />
          <Route path={`${ConsoleRouteMap.EVENT_SERIES.path}/*`} element={<EventSeries />} />
          <Route path={`${ConsoleRouteMap.REGISTRATION.path}/*`} element={<Registration />} />
          <Route path={`${ConsoleRouteMap.PROGRAM.path}/*`} element={<Program />} />
        </Route>
        <Route path={ConsoleRouteMap.LOGIN.path} element={<Login />} />
        <Route path={ConsoleRouteMap.FORGOT_PASSWORD.path} element={<ForgotPassword />} />
        <Route path={ConsoleRouteMap.RESET_PASSWORD.path} element={<ResetPassword />} />
        <Route path={ConsoleRouteMap.ACCEPT_USER_INVITE.path} element={<ResetPassword />} />
        <Route path={ConsoleRouteMap.ACCEPT_USER_ROLE.path} element={<AcceptUserRole />} />
        <Route path={ConsoleRouteMap.IFRAME.path}>
          <Route path={ConsoleRouteMap.IFRAME.EVENT_AGENDA.path} element={<EventAgendaInIFrame />} />
          <Route path={ConsoleRouteMap.IFRAME.SPONSOR_ORGANIZATION.path} element={<SponsorOrganizationInIFrame />} />
        </Route>
      </Routes>
      <ConsentProvider>
        <ConsentBannerContainer />
      </ConsentProvider>
    </Router>
  );
}
